export function PrivacyPolicyPage() {
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <h1 className="display-5 fw-bold mb-4">Privacy Policy</h1>
                    <p className="text-muted mb-5">Last updated: {new Date().toLocaleDateString()}</p>

                    <div className="privacy-content">
                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">1. Information We Collect</h2>
                            <p>
                                We collect information you provide directly to us, such as when you create an account, 
                                use our services, or contact us for support. This may include:
                            </p>
                            <ul>
                                <li>Personal information (name, email address, phone number)</li>
                                <li>Account credentials and preferences</li>
                                <li>Usage data and analytics</li>
                                <li>File metadata (not file contents)</li>
                            </ul>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">2. How We Use Your Information</h2>
                            <p>We use the information we collect to:</p>
                            <ul>
                                <li>Provide, maintain, and improve our services</li>
                                <li>Process transactions and send related information</li>
                                <li>Send technical notices and support messages</li>
                                <li>Respond to your comments and questions</li>
                                <li>Monitor and analyze usage patterns</li>
                            </ul>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">3. Information Sharing</h2>
                            <p>
                                We do not sell, trade, or otherwise transfer your personal information to third parties 
                                without your consent, except as described in this policy:
                            </p>
                            <ul>
                                <li>With service providers who assist in our operations</li>
                                <li>When required by law or to protect our rights</li>
                                <li>In connection with a business transfer or acquisition</li>
                            </ul>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">4. Data Security</h2>
                            <p>
                                We implement appropriate technical and organizational measures to protect your 
                                personal information against unauthorized access, alteration, disclosure, or destruction. 
                                However, no method of transmission over the internet is 100% secure.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">5. Cookies and Tracking</h2>
                            <p>
                                We use cookies and similar tracking technologies to enhance your experience, 
                                analyze usage patterns, and provide personalized content. You can control cookie 
                                settings through your browser preferences or our cookie consent banner.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">6. Your Rights</h2>
                            <p>You have the right to:</p>
                            <ul>
                                <li>Access and update your personal information</li>
                                <li>Request deletion of your data</li>
                                <li>Opt-out of marketing communications</li>
                                <li>Request data portability</li>
                                <li>Object to processing of your data</li>
                            </ul>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">7. Children's Privacy</h2>
                            <p>
                                Our services are not directed to children under 13. We do not knowingly collect 
                                personal information from children under 13. If we become aware that we have 
                                collected such information, we will delete it promptly.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">8. Changes to This Policy</h2>
                            <p>
                                We may update this privacy policy from time to time. We will notify you of any 
                                changes by posting the new policy on this page and updating the "Last updated" date.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">9. Contact Us</h2>
                            <p>
                                If you have any questions about this privacy policy, please contact us at:
                            </p>
                            <address>
                                <strong>Arcane Scale LLC</strong><br />
                                Email: info@arcanescale.com<br />
                                Website: <a href="https://www.arcanescale.com" target="_blank" rel="noopener noreferrer">
                                    www.arcanescale.com
                                </a>
                            </address>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}